import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'react-router-redux'

// Components
import Header from './app/header'
import App from './app/app'


export default function Root({ history, store }) {
  return (
    <Provider store={ store }>
      <ConnectedRouter history={ history }>
        <div>
          <Header />
          <App />
        </div>
      </ConnectedRouter>
    </Provider>
  )
}

Root.propTypes = {
  history: PropTypes.object.isRequired,
  store: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/components/root.js